import { FC } from "react";
import { CooldownButton, CooldownButtonProps } from "./CooldownButton"

export type HeroButtonProps = {

} & Omit<CooldownButtonProps, 'width' | 'height'>;

export const HeroButton: FC<HeroButtonProps> = ({ ...rest }) => {
    return (<CooldownButton width={256} height={182} {...rest} />);
}